import { useQuery } from '@mint-lib/query-client';
import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

type Options = {
  enabled: boolean;
  approvalProcessId: string | null;
};

const useFlowProcessDetailsData = ({ enabled, approvalProcessId }: Options) => {
  return useQuery({
    ...ApprovalFlows.getRequest({
      urlParams: {
        requestId: approvalProcessId ?? '',
      },
    }),
    enabled: Boolean(enabled && approvalProcessId),
    select: (data) => data.data?.items?.[0],
    staleTime: 60_000, // 1 minute
  });
};

export default useFlowProcessDetailsData;
